import {createTheme, ThemeOptions} from '@mui/material';
import {appColors as color} from '@provenant-dev/ui-kit';
import defaultTheme from '@provenant-dev/ui-kit/dist/src/theme';

export const appColors = {
  ...color,
  AppBarDefault: '#F5F5F5',
  black: '#000000',
  error: '#D32F2F',
  brandColors: {
    acme: '#004CB5',
    att: '#00549E',
    audio: '#7E57C2',
    colt: '#2C3E50',
    default: '#004CB5',
    error: '#ED5353',
    microsoft: '#004CB5',
    nuso: '#1A2F2F',
    orange: '#212121',
    success: '#8CFF00',
    tata: '#90A4AE',
    transNexus: '#455A64',
    vodafone: '#1A237E',
  },
  headerFooterShadow: `
                      0px 4px 6px rgba(18, 18, 23, 0.05), 
                      0px 10px 15px rgba(18, 18, 23, 0.08)
                    `,
  mainMenuItemDisabled: '#000014',
  mainMenuItemSelected: '#e5e5e6',
  missing: '#90A4AE',
  revoked: '#9E000D',
  sidebarBackground: '#f9f9fa',
  success: '#388E3C',
  toastBackground: '#F9F9FA',
  toastBorder: '#E8E8E8',
  valid: '#0A6104',
  white: '#FFFFFF',
};

const theme = createTheme(defaultTheme as ThemeOptions, {
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ':root': {
          '--sidebar-background': appColors.sidebarBackground,
          '--appBar-default-fill': appColors.AppBarDefault,
          '--main-menu-item-selected': appColors.mainMenuItemSelected,
          '--main-menu-item-disabled': appColors.mainMenuItemDisabled,
          '--white-color': appColors.white,
          '--border-color': appColors.border,
        },
      },
    },
  },
  typography: {
    fontSize: 16,
  },
  palette: {
    text: {
      secondary: '#4A4A4A',
    },
  },
});

export default theme;
